import "./header.css";

export default function Header() {
  return (
    <div className="header">
      <div className="headerTitles">
        <span className="headerTitleSm">Modern 🌍 World</span>
        <span className="headerTitleLg">Blog</span>
      </div>
      <img
        className="headerImg"
        src="https://miro.medium.com/max/4066/1*W3PACKchWkI6it12KJtewQ.jpeg"
        alt=""
      />
    </div>
  );
}
